var map = {
	"./admin.svg": 285,
	"./file.svg": 286,
	"./new-file.svg": 287,
	"./shared.svg": 288,
	"./upload.svg": 289,
	"./user.svg": 290
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 284;


//////////////////
// WEBPACK FOOTER
// ./src/assets \.svg$
// module id = 284
// module chunks = 0